import React, { useEffect, useState } from 'react';
import Card from '../components/Card/Card';
import Header from '../components/Header/Header';

function App() {
  const [cards, setCards] = useState([]);
  const [isAdmin, setIsAdmin] = useState(() => {
    const token = localStorage.getItem('token');
    return token && JSON.parse(atob(token.split('.')[1])).is_admin;
  });
  
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${apiUrl}/api/cards`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Falha na requisição');
        }
        return response.json();
      })
      .then(data => {
        setCards(data);
      })
      .catch(error => console.error("Erro ao buscar cards:", error));
    const token = localStorage.getItem('token');
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      setIsAdmin(payload.is_admin);
    }
  }, [apiUrl]);

  const updateCardInState = (updatedCard) => {
    setCards(currentCards =>
      currentCards.map(card =>
        card.id === updatedCard.id ? updatedCard : card
      )
    );
  };

  return (
    <>
      <Header />
      <div className="bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 m-4">
            {cards.map((card) => (
              <Card
                key={card.id}
                id={card.id}
                title={card.title}
                content={card.content}
                buttonText={card.button_text}
                buttonHref={card.button_href}
                isAdmin={isAdmin}
                onUpdate={updateCardInState}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default App;